import { useEffect } from "react"
import { Column, Row } from "../components/Layout"
import Card from "../components/Card"
import TextLabel from "../components/typography/TextLabel"
import TextBanner from "../components/typography/TextBanner"
import TextSubtitle from "../components/typography/TextSubtitle"

function LogTypeCard({ title, description, onPress }: { title: string, description: string, onPress?: () => void }) {

    return <Card className='scale-on-hover' fullWidth isPressable disableRipple onPress={onPress}>
        <Column>
            {title}
            <TextSubtitle>{description}</TextSubtitle>
        </Column>
    </Card>
}

export default function Logs() {

    useEffect(() => {
        const regionSelector = document.getElementsByClassName('custom-region-selector')[0]
        regionSelector?.remove()
    }, [])

    return <Row expand>
        <Column className='w-3/12' expand>
            <Card className="h-full" fullWidth>
                <Column >
                    <TextBanner>
                        System Logs
                    </TextBanner>
                    <TextSubtitle>Select logs to view</TextSubtitle>
                    <LogTypeCard title="Job Scanner" description="Module that scrapes the websites for job listing URLs." />
                    <LogTypeCard title="Job Page Scanner" description="Module that scrapes the content of job listing pages." />
                    <LogTypeCard title="Marlean Job Sync" description="Module that sends the scraped data to Marlean." />
                </Column>
            </Card>
        </Column>
        <Column className='w-9/12' expand>
            <Card className="h-full" fullWidth>

            </Card>
        </Column>
    </Row>
}